import React from 'react';
import { Eye, Target, Brain, Lock } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function PillarsSection() {
  const pillars = [{
    icon: <Eye className="w-6 h-6 text-red-500" data-id="element-274" />,
    title: 'Lenguaje de Precio',
    subtitle: '(Fundamento)',
    desc: 'Criterio real para leer el mercado sin depender de un tercero.'
  }, {
    icon: <Target className="w-6 h-6 text-red-500" data-id="element-275" />,
    title: 'Protocolo Sniper OTC',
    subtitle: '(Ejecución)',
    desc: 'Patrón 5–7, ticks, validación y entrenamiento.'
  }, {
    icon: <Brain className="w-6 h-6 text-red-500" data-id="element-276" />,
    title: 'Tu Yo Perfecto',
    subtitle: '(Mentalidad)',
    desc: 'Ejecución fría, consistencia y disciplina real para el trading.'
  }];
  return <section id="pilares" className="py-24 md:py-32 bg-neutral-950" data-id="element-277">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-278">
        <FadeIn data-id="element-279">
          <div className="text-center mb-16 md:mb-24" data-id="element-280">
            <span className="text-xs font-bold tracking-[0.2em] text-red-500 uppercase mb-4 block" data-id="element-281">
              El Sistema
            </span>
            <h2 className="text-3xl md:text-5xl font-black text-white tracking-tight uppercase" data-id="element-282">
              Protocolo Sniper se construye en{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-red-700" data-id="element-283">
                3 pilares
              </span>
            </h2>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mb-16" data-id="element-284">
          {pillars.map((pillar, idx) => <FadeIn key={idx} delay={0.1 * (idx + 1)} className="h-full" data-id="element-285">
              <div className="bg-[#121212] border border-neutral-800 p-8 h-full flex flex-col hover:border-neutral-600 transition-colors rounded-sm group" data-id="element-286">
                <div className="w-12 h-12 bg-neutral-900 flex items-center justify-center rounded-sm border border-neutral-800 mb-6 group-hover:border-red-500/50 transition-colors" data-id="element-287">
                  {pillar.icon}
                </div>
                <h3 className="text-xl font-bold text-white mb-1" data-id="element-288">
                  {pillar.title}
                </h3>
                <span className="text-xs font-mono text-neutral-500 mb-4 block" data-id="element-289">
                  {pillar.subtitle}
                </span>
                <p className="text-neutral-400 text-sm leading-relaxed mt-auto" data-id="element-290">
                  {pillar.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.5} data-id="element-291">
          <div className="bg-neutral-900 border border-neutral-800 p-6 md:p-8 rounded-sm flex flex-col md:flex-row items-start md:items-center gap-6 relative overflow-hidden" data-id="element-292">
            {/* Decorative accent */}
            <div className="absolute left-0 top-0 bottom-0 w-1 bg-red-600" data-id="element-293" />

            <div className="w-12 h-12 bg-neutral-950 border border-neutral-800 flex items-center justify-center rounded-sm shrink-0" data-id="element-294">
              <Lock className="w-5 h-5 text-neutral-400" data-id="element-295" />
            </div>

            <div data-id="element-296">
              <div className="flex items-center gap-3 mb-2" data-id="element-297">
                <h4 className="text-white font-bold uppercase tracking-wide" data-id="element-298">
                  ASISTENTE VISUAL SNIPER
                </h4>
                <span className="text-[10px] font-bold tracking-wider bg-red-600/10 text-red-500 px-2 py-1 rounded-sm border border-red-600/20" data-id="element-299">
                  EXCLUSIVO MENTORÍA
                </span>
              </div>
              <p className="text-neutral-400 text-sm" data-id="element-300">
                Se libera por mérito.{' '}
                <strong className="text-neutral-200 font-medium" data-id="element-301">
                  No opera por vos:
                </strong>{' '}
                acelera la lectura y reduce errores comunes, buscar entradas
                donde no las hay.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}